/**
 * MyBookmark
 */

import MyList from './MyList';
import Config from '../../Config';

class MyBookmark extends MyList {
	constructor( node: any, options: any ) {
		super( node, options );

		const configL10N = Config.L10N;
		configL10N.btn_delete = configL10N.btn_bookmark_delete;
		configL10N.alert_delete_article = configL10N.alert_delete_bookmark;
	}

	public get() {
		super.get( Config.scrapList() );
	}
}

export default MyBookmark;
